/**
 * @generated SignedSource<<b14f761de33ade933f6199a67fff2dc7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NotificationFilterChoice = "ACTION_ITEMS" | "COMMENTS" | "FEEDBACK" | "NOTES_EDITED" | "OBJECTIVES" | "RECORDING_ADDED" | "STREAM" | "TALKING_POINTS" | "USER_DELEGATION";
export type NotificationCenter_SetFiltersMutation$variables = {
  enabledFilters: ReadonlyArray<NotificationFilterChoice>;
};
export type NotificationCenter_SetFiltersMutation$data = {
  readonly NotificationCenter_SetFilters: {
    readonly notificationCenter: {
      readonly id: string;
      readonly notificationPanelFilters: ReadonlyArray<{
        readonly key: NotificationFilterChoice;
        readonly value: boolean | null;
      }>;
      readonly otherNotificationCount: number;
      readonly unreadNotificationCount: number;
      readonly " $fragmentSpreads": FragmentRefs<"NotificationCenter_List">;
    };
  } | null;
};
export type NotificationCenter_SetFiltersMutation = {
  response: NotificationCenter_SetFiltersMutation$data;
  variables: NotificationCenter_SetFiltersMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "enabledFilters"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "enabledFilters",
    "variableName": "enabledFilters"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unreadNotificationCount",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "otherNotificationCount",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "NotificationPanelFilterItem",
  "kind": "LinkedField",
  "name": "notificationPanelFilters",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "key",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "value",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v6 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 20
  }
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v9 = [
  (v8/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "NotificationCenter_SetFiltersMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ChangeNotificationPanelFilters",
        "kind": "LinkedField",
        "name": "NotificationCenter_SetFilters",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NotificationCenter",
            "kind": "LinkedField",
            "name": "notificationCenter",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "NotificationCenter_List"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "NotificationCenter_SetFiltersMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ChangeNotificationPanelFilters",
        "kind": "LinkedField",
        "name": "NotificationCenter_SetFilters",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NotificationCenter",
            "kind": "LinkedField",
            "name": "notificationCenter",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": (v6/*: any*/),
                "concreteType": "NotificationCenterConnection",
                "kind": "LinkedField",
                "name": "notifications",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NotificationCenterEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursorBefore",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "NotificationCenterEntry",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "verb",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "outerObject",
                            "plural": false,
                            "selections": [
                              (v7/*: any*/),
                              (v2/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": "title",
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "name",
                                    "storageKey": null
                                  }
                                ],
                                "type": "Account",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v8/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "eventTitle",
                                    "storageKey": null
                                  }
                                ],
                                "type": "Note",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": "title",
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "displayName",
                                    "storageKey": null
                                  }
                                ],
                                "type": "NoteStream",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v9/*: any*/),
                                "type": "FeedbackNode",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v9/*: any*/),
                                "type": "CommentThread",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v9/*: any*/),
                                "type": "Objective",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "unread",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "createdAt",
                            "storageKey": null
                          },
                          (v8/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "subtitle",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "body",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "url",
                            "storageKey": null
                          },
                          (v7/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasPreviousPage",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "startCursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "notifications(first:20)"
              },
              {
                "alias": null,
                "args": (v6/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "NotificationCenter_notifications",
                "kind": "LinkedHandle",
                "name": "notifications"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "bb4e33e18d75e5cd6c3d8a27d50311ae",
    "id": null,
    "metadata": {},
    "name": "NotificationCenter_SetFiltersMutation",
    "operationKind": "mutation",
    "text": "mutation NotificationCenter_SetFiltersMutation(\n  $enabledFilters: [NotificationFilterChoice!]!\n) {\n  NotificationCenter_SetFilters(enabledFilters: $enabledFilters) {\n    notificationCenter {\n      id\n      unreadNotificationCount\n      otherNotificationCount\n      notificationPanelFilters {\n        key\n        value\n      }\n      ...NotificationCenter_List\n    }\n  }\n}\n\nfragment NotificationCenter_List on NotificationCenter {\n  notifications(first: 20) {\n    edges {\n      cursorBefore\n      node {\n        id\n        verb\n        outerObject {\n          __typename\n          id\n        }\n        ...NotificationCenter_Notification\n        ...NotificationCenter_squashEditedNoteNotificationsNotification\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n      hasPreviousPage\n      startCursor\n    }\n  }\n  id\n}\n\nfragment NotificationCenter_Notification on NotificationCenterEntry {\n  id\n  unread\n  createdAt\n  title\n  subtitle\n  body\n  url\n  verb\n  outerObject {\n    __typename\n    ... on Account {\n      id\n      title: name\n    }\n    ... on Note {\n      id\n      title\n      eventTitle\n    }\n    ... on NoteStream {\n      id\n      title: displayName\n    }\n    ... on FeedbackNode {\n      id\n      title\n    }\n    ... on CommentThread {\n      id\n      title\n    }\n    ... on Objective {\n      id\n      title\n    }\n    id\n  }\n}\n\nfragment NotificationCenter_squashEditedNoteNotificationsNotification on NotificationCenterEntry {\n  id\n  verb\n  unread\n  url\n  createdAt\n  outerObject {\n    __typename\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "1973dd57bce0bffb9228560c12a895f2";

export default node;
